import React from "react"

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import BookmarkLists from "./components/linkie/Lists";
import AuthManager from "../utils/AuthManager";
import Event from "../utils/Event";
import Linkies from "./components/linkie/Linkies";

export default class Lists extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      currentUser: AuthManager.currentUser,
      selectedCollection: null,
    }
    this._setUpEvents()
  }

  _setUpEvents(){

  }

  _handleListSelect = (list) => {
    this.setState({ selectedCollection: list });
  }

  _handleBack = () => {
    this.setState({ selectedCollection: null });
  }

  render() {
    let {
      selectedCollection
    } = this.state

    return (
      <div className="pages manage-lists">
        <div className="g-5 gx-xxl-8">
          {selectedCollection ? (
            <div>
              <div className="d-flex align-items-center mb-4">
                <button
                  className="btn btn-sm btn-light btn-active-primary me-3"
                  onClick={this._handleBack}
                >
                  <i className="bi bi-arrow-left fs-4 me-1"></i>
                  Back
                </button>
                <h3 className="m-0 text-gray-800 fw-bold">{selectedCollection.name}</h3>
              </div>
              <Linkies type="customer" selectedList={selectedCollection} />
            </div>
          ) : (
              <div className="text-center">
                <BookmarkLists onListSelect={this._handleListSelect} />
              </div>
          )}
        </div>
      </div>
    )
  }

}